import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class NavigationService {
  private history: string[] = [];
  public previous = '';

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  back(): void {
    // this.history.pop();

    // if (this.history.length > 0) {
    this.location.back();
    // } else {
    //   this.router.navigateByUrl('/');
    // }
  }

  public refreshPage(path: any, params: any) {
    this.router.navigate([path], {queryParams: params});
  }

  // TODO move add library for deep copy
  public assignObjectValue(object: any, key: any, value: any) {
    // deep copy
    const obj = JSON.parse(JSON.stringify(object));
    value ? obj[key] = value : delete obj[key];
    // deep copy
    return JSON.parse(JSON.stringify(obj));
  }

  public navigateFromFilterTable(key: any) {
    for (let i = this.history.length - 1; i > 0; i--) {
      if (this.history[i].indexOf(key + '?') > -1 || this.history[i] == key) {
        this.router.navigateByUrl(this.history[i]);
        return;
      }
    }
    this.router.navigateByUrl(key);
  }
}
